;(function () {
  const GORGIAS_SRC = 'gorgias'
  const originalInsertBefore = Node.prototype.insertBefore
  const originalAppendChild = Node.prototype.appendChild

  let blockedSrc = null
  let blocking = true
  let started = false

  function isGorgiasScript(node) {
    return node && node.tagName === 'SCRIPT' && node.src && node.src.indexOf(GORGIAS_SRC) > -1
  }

  function releaseDomMethods() {
    if (!blocking) return
    blocking = false
    Node.prototype.insertBefore = originalInsertBefore
    Node.prototype.appendChild = originalAppendChild
  }

  // Shopify's ScriptTag loader injects the Gorgias bundle on window.load, from
  // content_for_header, which the theme cannot edit. The bundle initialises the widget
  // itself, so withholding GorgiasChat.init() does not stop it setting cookies. Intercept
  // the insertion instead and hold the URL until consent is given. This script is deferred,
  // so it always runs before window.load. Both insertion methods are covered so a change
  // to the loader cannot silently let the bundle through.
  Node.prototype.insertBefore = function (node, reference) {
    if (isGorgiasScript(node)) {
      blockedSrc = node.src
      releaseDomMethods()
      return node
    }
    return originalInsertBefore.call(this, node, reference)
  }

  Node.prototype.appendChild = function (node) {
    if (isGorgiasScript(node)) {
      blockedSrc = node.src
      releaseDomMethods()
      return node
    }
    return originalAppendChild.call(this, node)
  }

  // Nothing injects the bundle after window.load, so stop intercepting rather than
  // leaving the DOM methods patched for the lifetime of the page.
  window.addEventListener('load', function () {
    setTimeout(releaseDomMethods, 0)
  })

  function startGorgiasChat() {
    if (started) return
    started = true

    console.log('[gorgias] LOADING');
    // Must release before injecting, otherwise the block above catches our own script.
    releaseDomMethods()

    // Load the bundle ourselves if it was held back before consent was given.
    if (blockedSrc) {
      const script = document.createElement('script')
      script.async = true
      script.src = blockedSrc
      document.head.appendChild(script)
    }

    const initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise(function (resolve) {
          window.addEventListener('gorgias-widget-loaded', function () {
            resolve()
          })
        })

    initGorgiasChatPromise.then(() => {
      const gorgiasButtons = document.querySelectorAll('.js-gorigas-open')
      gorgiasButtons.forEach(function (gorgiasButton) {
        gorgiasButton.addEventListener('click', function (event) {
          event.preventDefault()
          if (GorgiasChat.isOpen()) {
            GorgiasChat.close()
          } else {
            GorgiasChat.open()
          }
        })
      })
    })

  }

  // Consent stored from an earlier visit. The event below only fires when consent is
  // collected, so returning visitors need the stored decision read on load.
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (!error && window.Shopify.customerPrivacy.currentVisitorConsent().preferences === 'yes') {
      startGorgiasChat()
    }
  })

  // Consent granted or changed during this page view.
  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail.preferencesAllowed) {
      startGorgiasChat()
    }
  })
})()
